// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.feedoverrides.floorplans.RentalManagerUserPropertyFeedFloorPlanWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  UserPropertyFeedFloorPlanCreateRequestDto,
  UserPropertyFeedFloorPlanCreateResponseWebDto,
  UserPropertyFeedFloorPlanDeleteRequestDto,
  UserPropertyFeedFloorPlanEditRequestDto,
} from '../..';

export const RentalManagerUserPropertyFeedFloorPlanWebApiHandler_create_Path =
  '/api/web/v1/users/properties/feedOverrides/floorPlans/create';

/**
 * Create a floor plan override on a feed listing
 */
export const RentalManagerUserPropertyFeedFloorPlanWebApiHandler_create = (
  postData: UserPropertyFeedFloorPlanCreateRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    UserPropertyFeedFloorPlanCreateRequestDto,
    UserPropertyFeedFloorPlanCreateResponseWebDto
  >(
    {
      endpoint: RentalManagerUserPropertyFeedFloorPlanWebApiHandler_create_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyFeedFloorPlanWebApiHandler_delete_Path =
  '/api/web/v1/users/properties/feedOverrides/floorPlans/delete';

/**
 * Delete a floor plan override on a feed listing
 */
export const RentalManagerUserPropertyFeedFloorPlanWebApiHandler_delete = (
  postData: UserPropertyFeedFloorPlanDeleteRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyFeedFloorPlanDeleteRequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyFeedFloorPlanWebApiHandler_delete_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyFeedFloorPlanWebApiHandler_edit_Path =
  '/api/web/v1/users/properties/feedOverrides/floorPlans/edit';

/**
 * Edit a floor plan override on a feed listing
 */
export const RentalManagerUserPropertyFeedFloorPlanWebApiHandler_edit = (
  postData: UserPropertyFeedFloorPlanEditRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyFeedFloorPlanEditRequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyFeedFloorPlanWebApiHandler_edit_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};
